import React, { useEffect, useState } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { productImg, LOGO } from "@/lib/ellaApi";

export default function ProductImageGallery({ images, productName }) {
  const [viewportRef, carousel] = useEmblaCarousel({ loop: true, align: "start" });
  const [selected, setSelected] = useState(0);

  useEffect(() => {
    if (!carousel) return;
    const sync = () => setSelected(carousel.selectedScrollSnap());
    sync();
    carousel.on("select", sync);
    carousel.on("reInit", sync);
    return () => { carousel.off("select", sync); carousel.off("reInit", sync); };
  }, [carousel]);

  useEffect(() => {
    if (!carousel || images.length < 2) return;
    const timer = setInterval(() => {
      if (document.visibilityState === "visible") carousel.scrollNext();
    }, 4500);
    return () => clearInterval(timer);
  }, [carousel, images.length, selected]);

  return (
    <div className="bg-gray-50" data-testid="product-image-gallery">
      <div ref={viewportRef} className="overflow-hidden" style={{ touchAction: "pan-y pinch-zoom" }}>
        <div className="flex">
          {images.map((image, index) => (
            <div key={image.ID || index} className="flex-[0_0_100%] min-w-0">
              <img src={productImg(image.ImagePath)} alt={`${productName} — foto ${index + 1}`}
                draggable={false} className="w-full aspect-square object-cover"
                onError={(event) => { event.currentTarget.onerror = null; event.currentTarget.src = LOGO; event.currentTarget.classList.add("object-contain", "p-12", "opacity-40"); }} />
            </div>
          ))}
        </div>
      </div>
      {images.length > 1 && <div className="flex gap-2 p-3 overflow-x-auto no-scrollbar">
        {images.map((image, index) => (
          <button key={image.ID || index} onClick={() => carousel?.scrollTo(index)} aria-label={`Lihat foto ${index + 1}`} aria-pressed={selected === index}
            className={`w-14 h-14 rounded-lg overflow-hidden border-2 shrink-0 ${selected === index ? "border-[#D32F2F]" : "border-transparent"}`}
            data-testid={`product-image-thumb-${index}`}>
            <img src={productImg(image.ImagePath)} alt="" className="w-full h-full object-cover" />
          </button>
        ))}
      </div>}
    </div>
  );
}
